/** Evita que Enter en la búsqueda del lookup dispare el submit del formulario padre. */
export function preventLookupSearchBubbling(event) {
  event.preventDefault();
  event.stopPropagation();
}
